<template>
    <div id="subOutputRank-print" class="page-break">
        <el-row>
            <el-col :span="6" :offset="9">
                <!-- <h1 style="text-align: center;margin-top: 0;padding-top: 0;color: #000">送货验收单</h1> -->
              <h1 style="font-size: 25px;font-weight:600;width: 100%;text-align: center" v-if="this.抬头名称">
                {{ 抬头名称 }}</h1>
              <h1 v-else style="text-align: center;margin-top: 0;padding-top: 0;color: #000 ;white-space: nowrap;">{{ this.companyName }}采购单</h1>
            </el-col>
        </el-row>
        <el-row>
            <el-col v-if="topData.length > 0" :span="9">
                <ul>
                    <li>供&nbsp;&nbsp;应&nbsp;&nbsp;商：{{topData[0].SUPPLIER_NAME}}</li>
                    <li>订&nbsp;单&nbsp;编号：{{topData[0].ORDER_CODE}}</li>
                </ul>
            </el-col>
            <el-col :span="12" style="padding-left: 70px">
                <ul>
                    <li></li>
                    <li>送&nbsp;货&nbsp;日&nbsp;期：{{topData[0].SEND_DAY}}</li>
                  <li v-if="是否打印订单ID">订&nbsp;单&nbsp;ID：{{topData[0].ORDER_ID}}</li>
                </ul>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <table style="width: 100%">
                    <tr>
                        <th style="width: 5%">序号</th>
                        <th style="width: 35%">名称</th>
                        <th style="width: 5%">单位</th>
                        <th style="width: 5%">订购</th>
                        <th style="width: 10%" v-if="flag">实收</th>
                        <th style="width: 10%" v-else>总金额</th>
                        <th style="width: 10%" v-if="productionDateFlag">生产日期</th>
                        <th style="width: 14%" v-if="是否带库位">库位</th>
                        <th style="width: 7%" v-if="是否带保质日期">保质日期</th>
                        <th style="width: 9%">备注</th>
                    </tr>
                    <tr v-for = "(item,index) in mainData[0]" :key="index">
                        <td>{{item.ID}}</td>
                        <td>{{item.PRODUCT_NAME}}</td>
                        <td>{{item.TYPE_UNIT}}</td>
                        <td>{{item.PRODUCT_COUNT}}</td>
                        <td v-if="flag">{{item.REAL_COUNT}}</td>
                        <td v-else>{{item.TOTAL_FEE}}</td>
                        <td v-if="productionDateFlag"></td>
                        <td v-if="是否带库位"></td>
                        <td v-if="是否带保质日期">{{item.QGP+ timeTypeList[item.QGP_TIME_TYPE]}}</td>
                        <td>{{item.PRODUCT_COMMENT}}</td>
                    </tr>
                </table>
            </el-col>
        </el-row>
        <!-- 新增 -->
        <el-row style="margin-top: 10px">
           <el-row>
            <el-col :span="6">
                <span>制单人：</span>
            </el-col>
            <el-col :span="6">
                <span>采购员：</span>
            </el-col>
            <el-col :span="6">
                <span>审批人：</span>
            </el-col>
            <el-col :span="6">
                <span>审核人：</span>
            </el-col>
        </el-row>
        </el-row>
        <el-row>
            <el-col :span="3" :offset="21" style="padding: 0">
                <p>第{{mainData[0].currentPage}}页/共{{mainData[0].totalPage}}页</p>
            </el-col>
        </el-row>
    </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    headerData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    manager: String,
    supplier: String,
  },
  data() {
    return {
      timeTypeList: ['', '年', '季', '月', '日', '时'],
      topData: [],
      mainData: [],
      managername: '',
      companyName: '',
      imgUrl: '',
      printSupplier: '',
      flag: false,
      productionDateFlag: false,
      是否带库位: false,
      是否带保质日期: false,
      抬头名称: sessionStorage.getItem('订单自定义名称'),
      是否打印订单ID: sessionStorage.getItem('打印订单ID'),
    };
  },
  created() {
    this.topData = this.headerData;
    this.mainData.push(this.tableData);
    this.managername = this.manager;
    this.printSupplier = this.supplier;
    this.companyName = sessionStorage.getItem('company');
    this.imgUrl = `https://service.linkda.com.cn/file/barcode/${this.topData[0].ORDER_ID}.png`;
    // this.imgUrl = 'http://47.99.59.146/file/barcode/'+ this.topData[0].ORDER_ID + '.png'
    if (Number(sessionStorage.getItem('realCountFlag')) !== 0) {
      this.flag = true;
    } else {
      this.flag = false;
    }
    if (Number(sessionStorage.getItem('productionDate')) !== 0) {
      this.productionDateFlag = true;
    }
    if (Number(sessionStorage.getItem('是否带库位')) !== 0) {
      // 1 是用户选择带 打印是带库位的 0 打印是不带库位的
      this.是否带库位 = true;
    }
    if (Number(sessionStorage.getItem('是否带保质日期')) !== 0) {
      // 1 是用户选择带 打印是带保质日期的 0 打印是不带保质日期的
      this.是否带保质日期 = true;
    }
  },
  beforeDestroy() {
    sessionStorage.removeItem('productionDate');
    sessionStorage.removeItem('是否带保质日期');
    sessionStorage.removeItem('是否带库位');
    sessionStorage.removeItem('订单自定义名称');
    sessionStorage.removeItem('打印订单ID');
  },
};
</script>
<style scoped>
    ul{
        margin-top: 0;
        padding-top: 0;
        padding-left: 0;
    }
    li{
        list-style: none;
        font-size: 20px;
        line-height: 30px;
        color: #000;
        font-family: 黑体;
    }
    span{
        font-size: 20px;
        line-height: 35px;
        color: #000;
        font-family: 黑体;
    }
    table {
        border-collapse: collapse;
        width: 130%;
        border: 1px solid #000;
        font-weight: bold;
    }
    td,th {
        border: 1px solid #000;
        text-align: center;
        font-weight: normal;
        font-size: 20px;
        height: 30px;
        font-family: 黑体;
        color: #000;
    }
</style>



// WEBPACK FOOTER //
// src/components/shopOrderManage/s_printTax.vue